import { node } from 'prop-types';
import React, { createContext, useCallback, useMemo, useState } from 'react';

export const CustomerContext = createContext({});

// The app context provider component
const CustomerContextProvider = ({ children }) => {
    // defaultCustomerContext is returned by the server on the initial render
    const [customerData, setCustomerData] = useState({});

    // Fetch customer data
    const fetchCustomerData = useCallback(async () => {
        try {
            const response = await fetch(new URL('api/customer', process.env.APP_URL));
            const data = await response.json();
            setCustomerData(data?.customer ?? {});
        } catch (e) {
            console.error(e);
        }
    }, []);
    const contextValue = useMemo(() => ({
        customerData,
        fetchCustomerData,
    }), [customerData, fetchCustomerData]);
    return (<CustomerContext.Provider
        value={contextValue}>
        {children}
    </CustomerContext.Provider>);
};

CustomerContextProvider.propTypes = {
    children: node,
};

export default CustomerContextProvider;